import { asyncRoutes } from '@/router/index.js'

const getMenuIdList = (arr) => {
  let menuIdList = []
  arr.forEach(item => {
    menuIdList.push(item.page)
    if (item.children && item.children.length) {
      menuIdList = menuIdList.concat(getMenuIdList(item.children))
    }
  })
  return menuIdList.filter(item => item)
}

const filterMenuList = (routes, menuIdList) => {
  return routes.filter(item => menuIdList.includes(item.id)).map(item => {
    item = Object.assign({}, item)
    if (item.children && item.children.length) {
      item.children = filterMenuList(item.children, menuIdList)
    }
    return item
  })
}

const dealRoutes = (arr) => {
  const list = getMenuIdList(arr)
  const menuList = filterMenuList(asyncRoutes, list)
  return menuList
}

export default dealRoutes